import { B9Routes } from 'crypto-b9/router'
import { routes88 } from 'crypto-88/router'
import type { RouteRecordRaw } from 'vue-router'
import { getTopCreditRouter } from './top-credit-router'

type RouterConfigMap = Partial<Record<ImportMetaEnv['VITE_PLATFORM'], RouteRecordRaw[]>>

export const getRouterConfigMap = (): RouterConfigMap => {
  return {
    88: routes88,
    b9: B9Routes,
    topcredit: getTopCreditRouter(),
  }
}
